import { IPaddings, ISizes } from 'utils/types'
/**
 * 1rem = 16px because :root set to 16px
 */
export const fontSizes: ISizes = {
  xs: '0.75rem' /* 12px */,
  sm: '0.875rem' /* 14px */,
  md: '1.125rem' /* 18px */,
  lg: '1.5rem' /* 24px */,
  xl: '2.375rem' /* 38px */
}

export const headingSizes: ISizes = {
  xs: '1.25rem' /* 20px */,
  sm: '1.5rem' /* 24px */,
  md: '2rem' /* 32px */,
  lg: '2.625rem' /* 42px */,
  xl: '3.5rem' /* 56px */
}

export const inputSizes: ISizes = {
  sm: '1.5rem' /* 24px */,
  md: '2rem' /* 32px */,
  lg: '3rem' /* 48px */,
  xl: '4rem' /* 64px */
}

export const inputFonts: ISizes = {
  xs: '0.625rem' /* 10px */,
  sm: '0.75rem' /* 12px */,
  md: '0.875rem' /* 14px */,
  lg: '1.1563rem' /* 18.5px */,
  xl: '1.5rem' /* 24px */
}

export const inputLabels: ISizes = {
  sm: '0.75rem' /* 12px */,
  md: '0.875rem' /* 14px */,
  lg: '0.875rem' /* 14px */,
  xl: '1.125rem' /* 18px */
}

export const buttonFonts: ISizes = {
  sm: '0.75rem' /* 12px */,
  md: '0.875rem' /* 14px */,
  lg: '1.125rem' /* 18px */,
  xl: '1.5rem' /* 24px */
}

/*
 * height factors in font size,
 * ie xl 1.25rem padding will create 64px height button
 */
export const buttonSizes: IPaddings = {
  sm: [0.4375, 1, 0.4375, 1], // 7px 16px 7px 16px
  md: [0.5625, 1.5, 0.5625, 1.5], // 9px 24px 9px 24px
  lg: [0.9375, 2, 0.9375, 2], // 15px 32px 15px 32px
  xl: [1.25, 2, 1.25, 2] // 20px 32px 20px 32px
}
